import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as PrizesActions, Types as PrizesTypes } from 'store/ducks/prizes';

function* getPrizeRequest(action) {
  try {
    const { id } = action.payload;
    const url = `experience/v2/customer_point_prizes/${id}`;
    const response = yield call(api.get, url);

    yield put(PrizesActions.getPrizeSuccess(response.data));
  } catch (error) {
    yield put(PrizesActions.getPrizeFailure());
  }
}

function* getPrizesRequest(action) {
  try {
    const { page } = action.payload;
    const url = `experience/v2/customer_point_prizes?page=${page}&per=25`;

    const response = yield call(api.get, url);

    yield put(PrizesActions.getPrizesSuccess(response.data));
  } catch (err) {
    console.log(err);
    yield put(PrizesActions.getPrizesFailure());
  }
}

function* createPrizeRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'experience/v2/customer_point_prizes';
    yield call(api.post, url, data);

    yield put(push('/points/prizes'));
    yield put(push('/points/prizes'));
    yield call(swal, 'Adicionado', 'Nova premiação adicionada', 'success');
    yield put(PrizesActions.createPrizeSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar a premiação', 'error');
    yield put(PrizesActions.createPrizeFailure());
  }
}

function* updatePrizeRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `experience/v2/customer_point_prizes/${id}`;
    yield call(api.put, url, data);

    yield put(push('/points/prizes'));
    yield put(push('/points/prizes'));
    yield call(swal, 'Atualizado', 'Premiação atualizada', 'success');
    yield put(PrizesActions.updatePrizeSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar a premiação.', 'error');
    yield put(PrizesActions.updatePrizeFailure());
  }
}

function* deletePrizeRequest(action) {
  try {
    const { id } = action.payload;
    const url = `experience/v2/customer_point_prizes/${id}`;
    yield call(api.delete, url);

    yield put(push('/points/prizes'));
    yield put(push('/points/prizes'));
    yield call(swal, 'Deletado', 'Premiação deletada', 'success');
    yield put(PrizesActions.deletePrizeSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao deletar', 'Não foi possível deletar a premiação.', 'error');
    yield put(PrizesActions.deletePrizeFailure());
  }
}

export default function* sagaPrizes() {
  yield takeLatest(PrizesTypes.GET_REQUEST, getPrizeRequest);
  yield takeLatest(PrizesTypes.GET_LIST_REQUEST, getPrizesRequest);
  yield takeLatest(PrizesTypes.CREATE_REQUEST, createPrizeRequest);
  yield takeLatest(PrizesTypes.UPDATE_REQUEST, updatePrizeRequest);
  yield takeLatest(PrizesTypes.DELETE_REQUEST, deletePrizeRequest);
}
